var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-content no-access"},[_c('section',[_c('h2',[_vm._v("ADMIN ACCESS")]),_vm._v(" "),_c('p',[_vm._v("You do not have access to web admin tools. ")])])])
}]

export { render, staticRenderFns }